import { Stack, SxProps, Theme } from "@mui/material";

const PulsingGreenDot: React.FC<{ sx?: SxProps<Theme> }> = ({ sx }) => {
    return (
        <Stack
            sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "18px",
                height: "18px",
                ...sx,
            }}
        >
            <Stack
                sx={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: "#1ba51f",
                    borderRadius: "50%",
                    position: "relative",
                    zIndex: 2,
                }}
            />
            <Stack
                sx={{
                    position: "absolute",
                    width: "18px",
                    height: "18px",
                    backgroundColor: "#1ba51f",
                    borderRadius: "50%",
                    opacity: 0.6,
                    animation: "ripple 1.5s infinite",
                    "@keyframes ripple": {
                        "0%": {
                            transform: "scale(0.8)",
                            opacity: 0.6,
                        },
                        "50%": {
                            transform: "scale(1.2)",
                            opacity: 0.3,
                        },
                        "100%": {
                            transform: "scale(1.6)",
                            opacity: 0,
                        },
                    },
                }}
            />
        </Stack>
    );
};

export default PulsingGreenDot